<template>
    <v-tabs
        v-model="selectedTab"
        background-color="transparent"
        class="denser-tabs"
        slider-size="4"
    >
        <v-tab
            v-for="tab in filteredTabs"
            :key="tab.id"
            :test-id="`app-store-tab_${tab.name}`"
        >
            <span class="caption font-weight-medium">
                {{ tab.text }}
            </span>
        </v-tab>
    </v-tabs>
</template>

<script>
import { computed } from "@vue/composition-api";
import appStoreDialog from "@/store/modules/AppStoreDialog/appStoreDialog";
import { TAB_NAMES } from "@/views/AppStore/app-tabs";

export default {
    name: "AppStoreTabs",
    setup(props, ctx) {
        const {
            appStoreDialogActions,
            appStoreDialogGetters,
        } = appStoreDialog()

        const allTabs = computed(() => appStoreDialogGetters.getTabs());
        const filteredTabs = computed(() => {
            return allTabs.value.filter((tab) => {
                if (Object.prototype.hasOwnProperty.call(tab, 'if')) return tab.if()
                return true
            });
        })

        const selectedTab = computed({
            get: () => {
                return appStoreDialogGetters.getSelectedTab()
            },
            set: (value) => {
                let tab = filteredTabs.value[value]
                if (tab){
                    appStoreDialogActions.updateCurrentTab(tab.name)
                }
            }
        })

        appStoreDialogActions.updateCurrentTab(TAB_NAMES.OVERVIEW);

        return {
            filteredTabs,
            selectedTab
        }
    }
};
</script>
